import React from 'react';
import { FailedStatusWrapper } from '../FailedStatusWrapper/FailedStatusWrapper';
import { astralWalletPostMessageToParent } from '../../../../components/PaymentsMethod/AstralWallet/utils/astralWalletPostMessageToParent';
import { useAuthStore, useCheckoutStore, useTranslation } from 'mycheck-core';
import { AstralWalletPaymentType } from 'plugins/CheckoutPlugin/types/CheckoutTypes';
import { AstralWalletIFrameMessage } from 'plugins/CheckoutPlugin/components/PaymentsMethod/AstralWallet/constants';
import { useAstralWalletStatus } from '../context/AstralWalletStatusContext';

interface CheckoutFailedProps {
  paymentType: AstralWalletPaymentType;
  paymentId: string;
}

export const CheckoutFailed: React.FC<CheckoutFailedProps> = ({
  paymentType,
  paymentId,
}) => {
  const { t } = useTranslation();
  const CheckoutStore = useCheckoutStore();
  const AuthStore = useAuthStore();
  const { retryAstralWalletStatusInterval } = useAstralWalletStatus();

  const handleTryAgainBtnClick = async () => {
    await CheckoutStore.retryAstralWalletCheckout({
      model: { paymentId },
      accessToken: AuthStore.accessToken,
    });
    retryAstralWalletStatusInterval();
  };

  const handleCancelBtnClick = () => {
    astralWalletPostMessageToParent({
      type: AstralWalletIFrameMessage.CANCEL_ORDER,
      payload: t(`astralWallet.${paymentType}.cancelledDescription`),
    });
  };

  return (
    <FailedStatusWrapper
      title={t('astralWallet.checkoutFailedTitle')}
      primaryBtnLabel={t('astralWallet.tryAgainLabel')}
      secondaryBtnLabel={t('astralWallet.cancelLabel')}
      onPrimaryBtnClick={handleTryAgainBtnClick}
      onSecondaryBtnClick={handleCancelBtnClick}
    >
      <p>{t(`astralWallet.${paymentType}.checkoutFailedDescription`)}</p>
    </FailedStatusWrapper>
  );
};
